import * as React from 'react';

import { Button, Container, Content } from './textBox.styled';
import { TextBoxProps } from './textBox.types';

export const TextBox: React.FC<TextBoxProps> = (props: TextBoxProps) => {
  const { textBoxTheme, content, buttonLabel, buttonAction, className }: TextBoxProps = props;

  return (
    <Container $theme={textBoxTheme} className={className}>
      <Content $theme={textBoxTheme} text={content} />
      {!!buttonLabel && <Button $theme={textBoxTheme} onClick={buttonAction}>{buttonLabel}</Button>}
    </Container>
  );
};
